import qs from 'qs'

export const queryEventEntryExtremeDateTimeRange = (locale: QueryLocaleString, sort: any) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      sort: sort || ['sortKeyAsc:asc', 'sortKeyDesc:asc'],
      pagination: {
        limit: 1
      },
      fields: [
        'sortKeyAsc',
        'sortKeyDesc'
      ]
    },
    {
      encodeValuesOnly: true
    }
  )
  return `event-entries?${query}`
}
